
export enum GenerationLevel {
  Type = 'type',
  Slot = 'slot'
}

export enum GenerationTextType {
  Expression = 'expression',
  Template = 'template',
  Code = 'code',
}

export enum GenerationTag {
  // expressions
  ExpressionEntityName = 'expression_entity_name',
  ExpressionEntityDontCare = 'expression_entity_dont_care',
  ExpressionEntityPronoun = 'expression_entity_pronoun',

  ExpressionFrameName = 'expression_frame_name',
  ExpressionFrame = 'expression_frame',
  ExpressionFrameNegative = 'expression_frame_negative',
  ExpressionFrameDontCare = 'expression_frame_dont_care',

  ExpressionSkillName = 'expression_skill_name',
  ExpressionSkill = 'expression_skill',
  ExpressionSkillNegative = 'expression_skill_negative',
  ExpressionSkillEntailment = 'expression_skill_entailment',

  ExpressionSlot = 'expression_slot',
  ExpressionSlotUpdate = 'expression_slot_update',
  ExpressionSlotDontCare = 'expression_slot_dont_care',
  ExpressionSlotCompanion = 'expression_slot_companion',

  ExpressionTypeExplicitConfirmationAffirmative = 'expression_type_explicit_confirmation_affirmative',
  ExpressionTypeExplicitConfirmationNegative = 'expression_type_explicit_confirmation_Negative',
  ExpressionSlotExplicitConfirmationAffirmative = 'expression_slot_explicit_confirmation_affirmative',
  ExpressionSlotExplicitConfirmationNegative = 'expression_slot_explicit_confirmation_Negative',
  ExpressionBooleanGateAffirmative = 'expression_boolean_gate_affirmative',
  ExpressionBooleanGateExplicitConfirmationNegative = 'expression_boolean_gate_Negative',

  // templates
  TemplateResponseSingleValueMessage = 'template_response_single_value_message',
  TemplateTransitionSingleValueMessage = 'template_transition_single_value_message',
  TemplatePostFillSingleValueMessage = 'template_post_fill_single_value_message',
  TemplateResponseMultipleValueMessage = 'template_response_multiple_value_message',
  TemplateTransitionMultipleValueMessage = 'template_transition_multiple_value_message',
  TemplatePostFillMultipleValueMessage = 'template_post_fill_multiple_value_message',

  TemplatePrompt = 'template_prompt',
  TemplateInform = 'template_inform',

  TemplateTypeVRHeader = 'template_prompt_type_vr_header',
  TemplateTypeVRBody = 'template_prompt_type_vr_body',
  TemplateTypeVRFooter = 'template_prompt_type_vr_footer',

  TemplateTypeVRSingleEntryInform = 'template_prompt_type_vr_single_entry_inform',
  TemplateTypeVRZeroEntryInform = 'template_prompt_type_vr_zero_entry_inform',

  TemplateSlotVRHeader = 'template_prompt_Slot_vr_header',
  TemplateSlotVRBody = 'template_prompt_Slot_vr_body',
  TemplateSlotVRFooter = 'template_prompt_Slot_vr_footer',

  TemplateSlotVRSingleEntryInform = 'template_prompt_Slot_vr_single_entry_inform',
  TemplateSlotVRZeroEntryInform = 'template_prompt_Slot_vr_zero_entry_inform',

  TemplateTypeImplicitConfirmationSingleValueMessage = 'template_prompt_type_implicit_confirmation_single_value_message',
  TemplateTypeImplicitConfirmationMultipleValueMessage = 'template_prompt_type_implicit_confirmation_multiple_value_message',

  TemplateTypeExplicitConfirmationSingleValueMessage = 'template_prompt_type_explicit_confirmation_single_value_message',
  TemplateTypeExplicitConfirmationMultipleValueMessage = 'template_prompt_type_explicit_confirmation_multiple_value_message',

  TemplateSlotImplicitConfirmationSingleValueMessage = 'template_prompt_slot_implicit_confirmation_single_value_message',
  TemplateSlotImplicitConfirmationMultipleValueMessage = 'template_prompt_slot_implicit_confirmation_multiple_value_message',

  TemplateSlotExplicitConfirmationSingleValueMessage = 'template_prompt_slot_explicit_confirmation_single_value_message',
  TemplateSlotExplicitConfirmationMultipleValueMessage = 'template_prompt_slot_explicit_confirmation_multiple_value_message',

  TemplateVCInform = 'template_vc_inform',
  TemplateBooleanGate = 'template_boolean_gate',

  // code
  Code = 'code'
}
